<template>
	<div class="flex flex-align-center">
		<rd-status class="ml-10" :statusType="statusObj.status"></rd-status>
		<div class="font-h6-regular color-gy-8">{{ statusObj.text }}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
	computed: {
		statusObj() {
			let statusObj = {
				status: '0',
				text: '',
			};
			switch (this.row.status) {
				case '0':
					statusObj.status = 'error';
					statusObj.text = '已删除';
					break;
				case '1':
					statusObj.status = 'todo';
					statusObj.text = '上架中';
					break;
				case '2':
					statusObj.status = 'fail';
					statusObj.text = '已下架';
			}
			return statusObj;
		},
	},
};
</script>